import React from 'react';
import DataTableChildBaseProps from './DataTableChildBaseProps';

export interface DataTableFilterByBaseProps<V = any, K extends keyof V = any> extends DataTableChildBaseProps {
    prop: K;
    labelText: string;
}

export default abstract class DataTableFilterByBase<P extends DataTableFilterByBaseProps<V, K>, V = any, K extends keyof V = any> extends React.Component<P> {}
